"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOidcFetch = exports.withOidcFetch = void 0;
const react_1 = __importDefault(require("react"));
const oidc_1 = __importDefault(require("./vanilla/oidc"));
const parseTokens_1 = require("./vanilla/parseTokens");
const initWorker_1 = require("./vanilla/initWorker");
const defaultConfigurationName = "default";
const fetchWithToken = (fetch, getOidcWithConfigurationName) => (...params) => __awaiter(void 0, void 0, void 0, function* () {
    const [url, options, ...rest] = params;
    const optionTmp = options ? Object.assign({}, options) : { method: "GET" };
    let headers = new Headers();
    if (optionTmp.headers) {
        headers = !(optionTmp.headers instanceof Headers)
            ? new Headers(optionTmp.headers)
            : optionTmp.headers;
    }
    const oidc = getOidcWithConfigurationName();
    // @ts-ignore
    const accessToken = oidc.tokens ? oidc.tokens.accessToken : null;
    // We wait the synchronisation before making a request
    while (oidc.tokens && accessToken && !(0, parseTokens_1.isTokensValid)(oidc.tokens)) {
        yield (0, initWorker_1.sleepAsync)(200);
    }
    if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json');
    }
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
        if (!optionTmp.credentials) {
            optionTmp.credentials = 'same-origin';
        }
    }
    const newOptions = Object.assign(Object.assign({}, optionTmp), { headers });
    return yield fetch(url, newOptions, ...rest);
});
const withOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => (WrappedComponent) => (props) => {
    const { fetch: newFetch } = (0, exports.useOidcFetch)(fetch || props.fetch, configurationName);
    return react_1.default.createElement(WrappedComponent, Object.assign({}, props, { fetch: newFetch }));
};
exports.withOidcFetch = withOidcFetch;
const useOidcFetch = (fetch = null, configurationName = defaultConfigurationName) => {
    const previousFetch = fetch || window.fetch;
    const getOidc = oidc_1.default.get;
    const getOidcWithConfigurationName = () => getOidc(configurationName);
    const newFetch = fetchWithToken(previousFetch, getOidcWithConfigurationName);
    return { fetch: newFetch };
};
exports.useOidcFetch = useOidcFetch;
//# sourceMappingURL=FetchToken.js.map